<template>
  <div class="hospital-db-layout-header">
    <header-top></header-top>
    <div class="header-m-menu">
      <a-row>
        <a-col :span="4" class="hmm-title">
          <img width="110"
        src="../../assets/image/analysis/logo_RONGLIAN_bioCloud.png"
      /></a-col>
        <a-col :span="16">
          <!-- <router-link to="/" class="hmm-rlink">表达</router-link>
          <router-link to="/" class="hmm-rlink">管理</router-link>
          <router-link to="/" class="hmm-rlink">帮助</router-link> -->
        </a-col>
        <a-col :span="4" class="hmm-right">
          <!-- <a-input-search placeholder="请输入基因名称" class="hm-search" /> -->
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import HeaderTop from "@/components/wordbench/header";
export default {
  components: { HeaderTop },
};
</script>

<style lang="scss" scoped>
.header-m-menu {
  padding: 0 20px;
  height: 48px;
  background: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.26);
  position: relative;
  z-index: 2;
  .hm-search {
    width: 230px;
    line-height: 47px;
  }
  .hmm-title {
    font-size: 14px;
    line-height: 47px;
  }
  .hmm-right{
    text-align: right;
  }
  .hmm-rlink {
    line-height: 46px;
    display: inline-block;
    padding: 0 10px 0 10px;
    margin-right: 60px;
    color: #9b9b9b;
    &.action {
      color: #558cf0;
    }
  }
}
</style>